var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.582 5.25a2.75 2.75 0 1 1 0 5.5 2.75 2.75 0 0 1 0-5.5m0 1.5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.582 2.583c1.789 0 3.311.788 4.474 1.695 1.164.909 2.02 1.98 2.499 2.65.162.228.443.575.443 1.072s-.28.844-.443 1.072c-.478.67-1.335 1.741-2.5 2.65-1.162.907-2.684 1.694-4.473 1.694s-3.31-.787-4.473-1.694c-1.164-.909-2.022-1.98-2.5-2.65-.143-.2-.375-.49-.431-.893L1.165 8l.013-.18c.056-.402.288-.693.43-.892.479-.67 1.337-1.74 2.5-2.65 1.163-.907 2.685-1.695 4.474-1.695m0 1.5c-1.337 0-2.541.589-3.55 1.377-1.008.787-1.77 1.732-2.202 2.339-.052.073-.09.126-.12.172l-.02.028.02.03c.03.045.068.099.12.172.433.607 1.194 1.551 2.201 2.338 1.01.788 2.214 1.377 3.551 1.377s2.54-.589 3.55-1.377c1.008-.787 1.77-1.731 2.202-2.338l.121-.173.018-.029q-.007-.012-.018-.028c-.03-.046-.069-.1-.12-.172-.433-.607-1.195-1.552-2.203-2.339-1.01-.788-2.213-1.377-3.55-1.377",
    clipRule: "evenodd"
  })));
};
export default Svg16;